import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Router
import {Redirect} from 'react-router-dom';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class MattersEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.matter_id,
      name: this.props.matter_data.name,
      short_name: this.props.matter_data.short_name,
      avaliation: this.props.matter_data.avaliation,
      hours_time: this.props.matter_data.hours_time,
      reference: this.props.matter_data.reference,
      grade: this.props.matter_data.grade,
    };

    //bind específico
    this.editar = this.editar.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.matter_id,
        name: newProps.matter_data.name,
        short_name: newProps.matter_data.short_name,
        avaliation: newProps.matter_data.avaliation,
        hours_time: newProps.matter_data.hours_time,
        reference: newProps.matter_data.reference,
        grade: newProps.matter_data.grade,
      });
    }
  }
  
  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      short_name: this.state.short_name,
      avaliation: this.state.avaliation,
      hours_time: this.state.hours_time,
      reference: this.state.reference,
      grade: this.state.grade,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.editar}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome da matéria:</label>
          <input type="text" name="name" className="form-control" placeholder="Nome da Matéria" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome Curto:</label>
          <input maxLength={5} type="text" name="short_name" className="form-control" placeholder="Nome Curto (05 caracteres)" value={this.state.short_name} onChange={this.handleChange.bind(this, 'short_name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Necessita de Avaliação?</label>
            <Select
              className="form-field-name"
              name="avaliation"
              value={this.state.avaliation}
              searchable={true}
              placeholder={'Necessita de Avaliação?'}
              onChange={this.handleSelectChange.bind(this, 'avaliation')}
              options={[
                {value: 0, label: "Não"},
                {value: 1, label: "Sim"}
              ]}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Carga horária:</label>
            <InputMask value={this.state.hours_time}  maskChar={null} name="hours_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'hours_time')} placeholder="Informe a carga horária no formato hh:mm" />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nota mínima:</label>
          <input type="grade" name="grade" disabled={this.state.avaliation === 0 ? "disabled" : ""} className="form-control" placeholder="Nota Mínima" value={this.state.grade} onChange={this.handleChange.bind(this, 'grade')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Referência:</label>
          <textarea style={{ height: 200 }} type="text" name="reference" className="form-control" value={this.state.reference} onChange={this.handleChange.bind(this, 'reference')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default MattersEditTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/MattersEditTab.js